export const UPDATE_NLP_STATE = "UPDATE_NLP_STATE"
export const GLOBAL_UPDATE_NLP_SNAPSHOT_IN_MESSAGE =
  "GLOBAL_UPDATE_NLP_SNAPSHOT_IN_MESSAGE"
